import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from '../views/Login.vue';
import Register from '../views/Register.vue';
import Recovery from '../views/Recovery.vue';
import Hmac from '../views/Hmac.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Login',
    component: Login,
  },
  {
    path: '/hmac',
    name: 'Hmac',
    component: Hmac,
  },
  {
    path: '/register',
    name: 'Register',
    component: Register,
  },
  {
    path: '/recovery',
    name: 'Recovery',
    component: Recovery,
  },
  {
    path: '/error',
    name: 'Error',
    props: true,
    component() {
      return import('../views/Error.vue');
    },
  },
];

const router = new VueRouter({
  routes,
});

export default router;
